import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import modalStyle from 'components/Modal/Modal.css'
import * as actInvoice from 'actions/reports/invoices'
import {connect} from 'react-redux'
import Item from 'components/receipt/refunds/RefundBreakdownModal/Item'
import AmountToRefund from 'components/receipt/refunds/AmountToRefund'
import Gratuity from 'components/receipt/refunds/RefundBreakdownModal/Gratuity'
import Tax from 'components/receipt/refunds/RefundBreakdownModal/Tax'
import Discount from 'components/receipt/refunds/RefundBreakdownModal/Discount'
import RewardRedemption from 'components/receipt/refunds/RefundBreakdownModal/RewardRedemption'
import RefundReason from 'components/receipt/refunds/RefundReason'
import './cancelInvoiceModal.css'
import moment from 'moment'
class CancelInvoiceModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      reasonForRefund: '',
      otherReasonForRefund: '',
      sending: false
    }
  }

  render () {
    let {openCancelInvoiceModal, receiptInvoices} = this.props.data.reports.invoices
    let items = {}
    for (var salesType in receiptInvoices.checkouts) {
      let itemST = receiptInvoices.checkouts[salesType].map((item) => {
        return {
          itemName: item.item_name,
          itemVariantName: item.item_variant_name,
          refundAmount: item.quantity
        }
      })
      items[salesType] = itemST
    }
    items = this._sortCheckouts(items)
    return (<Modal onHide={this._onHide} show={openCancelInvoiceModal} bsClass='cancel-invoice full-height-modal margin-top-modal modal'>
      <ModalHeader title='Cancel Invoice' />
      <Modal.Body bsClass={`${modalStyle['modal-body']} modal-body`}>
        <AmountToRefund calculateAmountToRefund={this._calculateAmountToRefund} />
        <Item
          isChecked={(idx) => {}}
          isSelectedAll={(idx) => {}}
          isRefunded={(idx) => {}}
          canBeRefunded={(idx) => {}}
          canSelectAll={() => false}
          onClickCheck={(idx) => {}}
          onClickSelectAll={(idx) => {}}
          onClickDeselectAll={(idx) => {}}
          onClickIncreaseQty={(idx) => {}}
          onClickDecreaseQty={(idx) => {}}
          onChangeInputAmountRefunded={(idx) => {}}
          refundItems={items}
          calculateItemPrice={this._calculateItemPrice}
          showCheckbox={false}
          isSalesType={receiptInvoices.is_sales_type}
        />
        <Discount
          paymentDiscounts={receiptInvoices.payment_discounts}
          calculateDiscount={this._calculateDiscount}
          />
        <RewardRedemption
          redeemReward={this._getRewardName()}
          redeemAmount={receiptInvoices.total_redeem_amount}
         />
        <Gratuity
          includeGratuityTax={receiptInvoices.include_gratuity_tax}
          paymentGratuities={receiptInvoices.payment_gratuities}
          calculateGratuity={this._calculateGratuity}
          />
        <Tax
          includeGratuityTax={receiptInvoices.include_gratuity_tax}
          paymentTaxes={receiptInvoices.payment_taxes}
          calculateTax={this._calculateTax}
          />
        <RefundReason
          className='refund-reason'
          labelReason='Reason for Cancelation'
          onChangeOtherReasonForRefund={this._onChangeOtherReasonForRefund}
          onChangeReasonForRefund={this._onChangeReasonForRefund}
          />
      </Modal.Body>
      <Modal.Footer>
        <div className='pull-left'>
          <button type='button' className='btn btn-default' onClick={this._onHide}>Cancel</button>
        </div>
        <div>
          <button
            type='button'
            className='btn btn-primary pull-right'
            disabled={!this._canCancelInvoice()}
            onClick={this._onClickIssueRefund}
            >
              Cancel Invoice
            </button>
        </div>
      </Modal.Footer>
    </Modal>)
  }

  _sortCheckouts = (checkouts) => {
    const sortedSt = {}
    const sortedNoSt = {}
    let key
    let a = []
    for (key in checkouts) {
      if (checkouts.hasOwnProperty(key)) {
        a.push(key)
      }
    }
    a.sort(this._insensitive)
    for (key = 0; key < a.length; key++) {
      if (a[key] !== 'No Sales Type') {
        sortedSt[a[key]] = checkouts[a[key]]
      } else {
        sortedNoSt[a[key]] = checkouts[a[key]]
      }
    }
    return Object.assign(sortedSt, sortedNoSt)
  }

  _insensitive = (s1, s2) => {
    var s1lower = s1.toLowerCase()
    var s2lower = s2.toLowerCase()
    return s1lower > s2lower ? 1 : (s1lower < s2lower ? -1 : 0)
  }

  _onHide = () => {
    this.setState({
      reasonForRefund: null
    })
    this.props.dispatch(actInvoice.hideCancelInvoiceModal())
  };

  _getRewardName = () => {
    const {receiptInvoices} = this.props.data.reports.invoices
    return receiptInvoices.loyalty && receiptInvoices.loyalty.type.toLowerCase() === 'redemption' ? receiptInvoices.loyalty.redemption.reward : ''
  }

  _onChangeOtherReasonForRefund = (value) => {
    this.setState({
      otherReasonForRefund: value
    })
  };

  _onChangeReasonForRefund = (value) => {
    this.setState({
      reasonForRefund: value
    })
  };

  _onClickIssueRefund = () => {
    this.setState({sending: true})
    let {receiptInvoices} = this.props.data.reports.invoices

    // construct taxes
    let taxes = receiptInvoices.payment_taxes.map((tax) => {
      return {
        'tax_id': tax.tax_id,
        'tax_percentage': tax.amount,
        'taxable_amount': -tax.taxable_amount,
        'tax_amount': -tax.total,
        'tax_name': tax.name
      }
    })

    // construct discounts
    let discounts = receiptInvoices.payment_discounts.map((discount) => {
      return {
        'discount_id': discount.discount_id,
        'discount_amount': -discount.discount_amount,
        'discount_type': discount.discount_type,
        'discount_name': discount.discount_name,
        'discount_cash': discount.discount_cash
      }
    })

    // construct gratuities
    let gratuities = receiptInvoices.payment_gratuities.map((gratuity) => {
      return {
        'gratuity_id': gratuity.gratuity_id,
        'gratuity_percentage': gratuity.amount,
        'gratuity_amount': -gratuity.total,
        'gratuity_name': gratuity.name
      }
    })
    let items = []
    for (var salesType in receiptInvoices.checkouts) {
      let itemST = receiptInvoices.checkouts[salesType].map((item) => {
        let checkoutDiscounts = []

        item.discounts.map((discount) => {
          discount.discount_hash.forEach((checkoutDiscount) => {
            checkoutDiscounts.push({
              'discount_id': checkoutDiscount.discount_id,
              'discount_name': checkoutDiscount.discount_name,
              'discount_type': checkoutDiscount.discount_type,
              'discount_cash': checkoutDiscount.discount_cash,
              'discount_percentage': checkoutDiscount.discount_percentage,
              'discount_amount': -checkoutDiscount.discount_amount
            })
          })
        })
        return {
          'parent_checkout_id': item.id,
          'item_id': item.item_id,
          'item_variant_id': item.item_variant_id,
          'item_name': item.item_name,
          'item_variant_name': item.item_variant_name,
          'item_variant_sku': item.sku,
          'item_image': item.item_image,
          'quantity': -item.quantity,
          'gross_sales': -item.gross_sales,
          'client_price': item.item_price,
          'discount_amount': -item.discount_amount,
          'net_sales': -item.net_sales,
          'gratuity': -item.gratuity_amount,
          'tax': -item.tax_amount,
          'track_stock': item.track_stock,
          'category_id': item.category_id,
          'category_name': item.category_name,
          'sales_type_id': item.sales_type_id,
          'sales_type_name': item.sales_type_name,
          'discounts': checkoutDiscounts,
          'modifiers': item.modifiers.map((modifier) => {
            return {
              'modifier_id': modifier.modifier_id,
              'modifier_name': modifier.modifier_name,
              'modifier_option_id': modifier.modifier_option_id,
              'modifier_option_name': modifier.modifier_option_name,
              'modifier_option_price': modifier.price,
              'gross_sales': -modifier.gross_sales,
              'net_sales': -modifier.net_sales,
              'discount_amount': -modifier.discount_amount,
              'modifier_discounts': modifier.discount_hash.map((modifierDiscount) => {
                modifierDiscount.discount_amount = -modifierDiscount.discount_amount
                return modifierDiscount
              })
            }
          })
        }
      })
      items = items.concat(itemST)
    }

    let loyalty = null
    if (receiptInvoices.loyalty) {
      loyalty = {
        new_earned_points: -receiptInvoices.loyalty.new_earned_points,
        program_id: receiptInvoices.loyalty.program_id,
        member_since: receiptInvoices.loyalty.member_since,
        earning_rule: receiptInvoices.loyalty.earning_rule,
        member_id: receiptInvoices.loyalty.member_id,
        member_uniq_id: receiptInvoices.loyalty.member_uniq_id,
        member_guid: receiptInvoices.loyalty.member_guid
      }

      if (receiptInvoices.loyalty.type.toUpperCase() === 'REDEMPTION') {
        let {redemption} = receiptInvoices.loyalty
        loyalty.redemption = {
          'redeem_points': redemption.redeem_points,
          'redeem_amount': -receiptInvoices.total_redeem_amount,
          'reward_type': redemption.reward_type,
          'reward_id': redemption.reward_id,
          'reward': redemption.reward,
          'discount': redemption.discount,
          'discount_type': redemption.discount_type
        }
      }
    }

    let data = {
      amount: receiptInvoices.total_collected,
      client_created_at: moment().format(),
      custom_reason: this.state.otherReasonForRefund,
      discounts: discounts,
      loyalty: loyalty,
      gratuities: gratuities,
      is_refund_transaction: true,
      items: items,
      payment_id: receiptInvoices.id,
      reason: this.state.reasonForRefund !== 'Other' ? this.state.reasonForRefund : this.state.otherReasonForRefund,
      refund_amount: receiptInvoices.total_net_sales,
      taxes: taxes,
      total_collected: -receiptInvoices.total_collected_amount,
      total_discount: -receiptInvoices.total_discount_amount,
      total_redeem_amount: -receiptInvoices.total_redeem_amount,
      total_gratuity: -receiptInvoices.total_gratuity_amount,
      total_gross_sales: -receiptInvoices.total_gross_sales,
      total_net_sales: -receiptInvoices.total_net_sales,
      total_tax: -receiptInvoices.total_tax_amount
    }

    this.props.dispatch(actInvoice.issueRefundRequest({refund: data}))
  };
  /***************************************************************************
   * Calculation
   ***************************************************************************/

  _calculateAmountToRefund = () => {
    let {receiptInvoices} = this.props.data.reports.invoices
    return receiptInvoices.total_collected
  };

  _calculateGratuity = (gratuityId) => {
    let {receiptInvoices} = this.props.data.reports.invoices
    let result = 0
    receiptInvoices.payment_gratuities.forEach((gratuity) => {
      if (gratuity.gratuity_id === gratuityId) {
        result = gratuity.total
      }
    })
    return result
  };

  _calculateTax = (taxId) => {
    let {receiptInvoices} = this.props.data.reports.invoices
    let result = 0
    receiptInvoices.payment_taxes.forEach((tax) => {
      if (tax.id === taxId) {
        result = tax.total
      }
    })
    return result
  };

  _calculateDiscount = (discountId) => {
    let {receiptInvoices} = this.props.data.reports.invoices
    let result = 0
    receiptInvoices.payment_discounts.forEach((discount) => {
      if (discount.discount_id === discountId) {
        result = discount.discount_amount
      }
    })
    return result
  }

  _calculateItemPrice = (salesType, idx) => {
    let {checkouts} = this.props.data.reports.invoices.receiptInvoices
    let price = checkouts[salesType][idx].price - this._calculateDiscountPercentage(checkouts[salesType][idx].discounts)
    if (price < 0) {
      return 0
    } else {
      return price
    }
  }

  _calculateDiscountPercentage (discounts) {
    let discountCash = 0
    discounts.forEach(discount => {
      if (discount.discount_hash) {
        discount.discount_hash.forEach(dis => {
          if (dis.discount_type === 'percentage') {
            discountCash += dis.discount_amount
          }
        })
      }
    })
    return discountCash
  }

  /***************************************************************************
   * End Calculation
   ***************************************************************************/

  _canCancelInvoice = () => {
     // refund reason is not empty, and if refundReason is 'Other', customReason is not empty
    return (this.state.reasonForRefund && (this.state.reasonForRefund !== 'Other' || this.state.otherReasonForRefund) && !this.state.sending)
  }
}

CancelInvoiceModal.propTypes = {

}

function mapStateToProps (state) {
  return {
    data: {
      reports: {
        invoices: state.reports.invoices
      }
    }
  }
}

export default connect(mapStateToProps)(CancelInvoiceModal)



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/CancelInvoiceModal/CancelInvoiceModal.js